import React from 'react';

export default function AskButton(props)
{
    const manage_click = (evt) =>
    {
        evt.stopPropagation();
        evt.preventDefault();
        window.location.href = props.conf.route.ask;
    };
    return <button className='button button-primary' onClick={manage_click}><i className="ui-icon-help"></i> Ask Question</button>
}